/***************************************************************
 * Evento "show.bs.tab" (antes de que se muestre la pesta�a)
 * Bloquea si est� deshabilitada (opcional)
 ***************************************************************/
$(document).on('show.bs.tab', '.tab-link', function (e) {
    if ($(this).hasClass('disabled')) {
        e.preventDefault();  // Cancela el cambio de pesta�a
        return;
    }
});

$(document).on('shown.bs.tab', '.tab-link', function (e) {
    const $this = $(this);
    const $tabContainer = $this.closest('.tab-container');
    const $backgroundIndicator = $tabContainer.find('.background-indicator');

    // Calcula tama�o y posici�n de la pesta�a actual
    const tabWidth = $this.outerWidth();
    const tabOffsetLeft = $this.offset().left - $tabContainer.offset().left;

    // Animaci�n de la barra
    $backgroundIndicator.stop().animate({
        width: tabWidth + 'px',
        left: tabOffsetLeft + 'px'
    }, 250);

    // Manejo de la clase 'active'
    $('.tab-link').removeClass('active');
    $this.addClass('active');

    // Manejo de clases para los bordes (flechas)
    const $tabs = $tabContainer.find('.tab-link');
    const index = $tabs.index($this);

    if (index === 0) {
        $backgroundIndicator.addClass('hide-before').removeClass('hide-after');
    } else if (index === $tabs.length - 1) {
        $backgroundIndicator.addClass('hide-after').removeClass('hide-before');
    } else {
        $backgroundIndicator.removeClass('hide-before hide-after');
    }
});

/***************************************************************
 * Funci�n para renumerar pesta�as (si la usas)
 ***************************************************************/
function initNumbertab() {
    var contador = 1;
    $(".tab-container").find("li:visible").each(function () {
        $(this).find('.number-tab').text(contador);
        contador++;
    });
}

/***************************************************************
 * Funciones para habilitar/deshabilitar tabs seg�n su "href"
 ***************************************************************/
export function enableTab(href) {
    $(`a[href="${href}"]`).removeClass('disabled');
}

export function disableTab(href) {
    $(`a[href="${href}"]`).addClass('disabled');
}
export function changeTab(targetId) {
    const $tab = $(`.tab-link[data-bs-target="${targetId}"], .tab-link[href="${targetId}"]`);

    if ($tab.length === 0) {
        console.warn(`La pesta�a con ID ${targetId} no existe.`);
        return;
    }

    if ($tab.hasClass('disabled')) {
        console.warn(`La pesta�a con ID ${targetId} est� deshabilitada.`);
        return;
    }

    const tabInstance = new bootstrap.Tab($tab[0]);
    tabInstance.show();
}


$(document).ready(function () {
    // Localizamos la pesta�a con .active
    const $activeTab = $('.tab-link.active');
    if ($activeTab.length) {
        const $tabContainer = $activeTab.closest('.tab-container');
        const $backgroundIndicator = $tabContainer.find('.background-indicator');
        const $tabs = $tabContainer.find('.tab-link');

        // Calcula tama�o y posici�n
        const tabWidth = $activeTab.outerWidth();
        const tabOffsetLeft = $activeTab.offset().left - $tabContainer.offset().left;

        // Posiciona la barra sin animaci�n
        $backgroundIndicator.css({
            width: tabWidth + 'px',
            left: tabOffsetLeft + 'px'
        });

        // Ajuste para flecha inicial: misma l�gica de shown.bs.tab
        const index = $tabs.index($activeTab);
        if (index === 0) {
            $backgroundIndicator.addClass('hide-before').removeClass('hide-after');
        } else if (index === $tabs.length - 1) {
            $backgroundIndicator.addClass('hide-after').removeClass('hide-before');
        } else {
            $backgroundIndicator.removeClass('hide-before hide-after');
        }
    }

    initNumbertab();
    applyCustomDropdownStyles();

    // Aplica estilo custom a selects Kendo cuando cambien
    $("select").on("change", function () {
        $(this).siblings(".k-dropdown-wrap")
            .removeClass("select-selected")
            .addClass("select-selected");
    });
});

function applyCustomDropdownStyles() {
    setTimeout(function () {
        $(".k-cmbox").each(function () {
            let dropdown = $(this).data("kendoDropDownList");

            if (dropdown) {
                dropdown.bind("change", function () {
                    dropdown.wrapper.find(".k-input-inner").css({
                        "background-color": "#E1FFD7",
                        "color": "#212529"
                    });
                });

                if (dropdown.value()) {
                    dropdown.wrapper.find(".k-input-inner").css({
                        "background-color": "#E1FFD7",
                        "color": "#212529"
                    });
                }
            }
        });
    }, 1000);
}

// Ejemplo de uso:
// disableTab('#tab-2');
// enableTab('#tab-2');
//changeTab('#tab2')
